// Auto-generated from AffiliationEnum

export const affiliation = {
  unknown: 'unknown',
  own: 'own',
  contact: 'contact',
}

export type TAffiliation = (typeof affiliation)[keyof typeof affiliation];
